const getDefaultState = () => ({
  availableDomains: {
    loading: false,
    error: false,
    items: [],
    delete: {
      deleting: false,
      error: false,
      success: false,
    },
    add: {
      adding: false,
      error: false,
      success: false,
    },
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/review-settings/defaultState.js